import {
    COMMUNITY_ITEM_RESPONSE,
    COMMUNITY_ITEM_SAVE_RESPONSE,
    COMMUNITY_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { normalise } from "../../models/entities/community"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case COMMUNITY_ITEM_SAVE_RESPONSE:
        case COMMUNITY_ITEM_RESPONSE:
            const { id } = data
            return {
                ...extractEntitiesFromData(data.communities, state),
                [id]: {
                    ...(state[id] || {}),
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        case COMMUNITY_LIST_RESPONSE:
            let memberCountData = data.map(community => ({
                ...community,
                member_count_string: getMemberCountString(
                    community.member_count
                )
            }))
            return extractEntitiesFromData(memberCountData, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}

function getMemberCountString(memberCount) {
    if (memberCount === 1) return "1 member"
    else if (memberCount > 1000000)
        return `${getMemberCountRounded(memberCount, 6)}M members`
    else if (memberCount > 1000)
        return `${getMemberCountRounded(memberCount, 3)}K members`
    else return `${memberCount} members`
}

function getMemberCountRounded(memberCount, powerOf10) {
    return Math.round(memberCount / 10 ** (powerOf10 - 1)) / 10
}
